import React from 'react';
import { Outlet } from 'react-router-dom';
import SystemHeader from './SystemHeader';

function SystemSettings() {
  return (
    <div>
      <SystemHeader />
      <div className="contents">
        <Outlet />
      </div>
    </div>
  );
}

export default SystemSettings;
